<template>
  <div class="report-container">
    <div class="report-header" v-if="!showAnalysis && !showStatistics && !showMediaAnalysis">
      <h2 class="report-title">レポート機能</h2>
      <p class="report-description">データ分析とレポーティング</p>
    </div>
    
    <div class="report-content">
      <!-- メインメニュー -->
      <div v-if="!showAnalysis && !showStatistics && !showMediaAnalysis" class="placeholder-box">
        <i class="mdi mdi-chart-line" style="font-size: 64px; color: #999;"></i>
        <h3>レポート機能</h3>
        <p>応募者データの分析やレポート生成機能をここに実装予定です</p>
        
        <div class="feature-list">
          <div class="feature-item" @click="showStatistics = true" style="cursor: pointer;">
            <i class="mdi mdi-chart-bar"></i>
            <span>応募者統計</span>
          </div>
          <div class="feature-item" @click="showAnalysis = true" style="cursor: pointer;">
            <i class="mdi mdi-calendar-range"></i>
            <span>絞込み分析</span>
          </div>
          <div 
            class="feature-item" 
            @click="handleMediaAnalysisClick" 
            :style="{ cursor: user.is_user ? 'pointer' : 'not-allowed', opacity: user.is_user ? 1 : 0.5 }"
          >
            <i class="mdi mdi-file-export"></i>
            <span>媒体別レポート</span>
          </div>
        </div>
      </div>

      <!-- 応募者統計画面（ApplicantStatistics.vueの内容を表示） -->
      <div v-if="showStatistics" class="statistics-container">
        <div class="statistics-header">
          <button @click="showStatistics = false" class="back-button">
            <i class="mdi mdi-arrow-left"></i> 戻る
          </button>
        </div>
        <!-- ApplicantStatistics.vueコンポーネントを埋め込み -->
        <div class="statistics-wrapper">
          <ApplicantStatistics :user="user" />
        </div>
      </div>

      <!-- 絞込み分析画面（Report.vueの内容を表示） -->
      <div v-if="showAnalysis" class="analysis-container">
        <div class="analysis-header">
          <button @click="showAnalysis = false" class="back-button">
            <i class="mdi mdi-arrow-left"></i> 戻る
          </button>
          <h2>絞込み分析</h2>
          <!-- ステップナビゲーション -->
          <div class="step-navigation">
            <div 
              class="step-item" 
              :class="{ active: currentStep === 1, completed: currentStep > 1 }"
              @click="currentStep = 1"
            >
              <div class="step-number">1</div>
              <div class="step-label">集計項目選択</div>
            </div>
            <div class="step-connector" :class="{ completed: currentStep > 1 }"></div>
            <div 
              class="step-item" 
              :class="{ active: currentStep === 2, completed: currentStep > 2 }"
              @click="currentStep = 2"
            >
              <div class="step-number">2</div>
              <div class="step-label">条件設定</div>
            </div>
            <div class="step-connector" :class="{ completed: currentStep > 2 }"></div>
            <div 
              class="step-item" 
              :class="{ active: currentStep === 3 }"
              @click="currentStep = 3"
            >
              <div class="step-number">3</div>
              <div class="step-label">集計テーブル</div>
            </div>
          </div>
        </div>
        <!-- Report.vueコンポーネントを直接埋め込み -->
        <div class="report-wrapper">
          <Report ref="reportComponent" :currentStep="currentStep" @update:currentStep="currentStep = $event" />
        </div>
      </div>
      
      <!-- 媒体別レポート画面 -->
      <div v-if="showMediaAnalysis" class="media-analysis-container">
        <div class="media-analysis-header">
          <button @click="showMediaAnalysis = false" class="back-button">
            <i class="mdi mdi-arrow-left"></i> 戻る
          </button>
          <h2>媒体別レポート</h2>
        </div>
        <!-- MediaAnalysisSectionコンポーネントを埋め込み -->
        <div class="media-analysis-wrapper">
          <MediaAnalysisSection
            :company-id="user.companyID || (user.company && user.company.company_hash)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Report from '@/views/DashBoard/Report/Report'
import ApplicantStatistics from '@/views/DashBoard/Report/ApplicantStatistics'
import MediaAnalysisSection from '@/views/DashBoard/Report/components/MediaAnalysisSection'

export default {
  name: 'ReportView',
  components: {
    Report,
    MediaAnalysisSection,
    ApplicantStatistics
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    isMenuMiniSize: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showAnalysis: false,
      showStatistics: false,
      showMediaAnalysis: false,
      currentStep: 1
    }
  },
  mounted() {
    console.log('ReportView mounted')
  },
  methods: {
    // 媒体別レポートモーダルを開く際のメソッド
    handleMediaAnalysisClick() {
      if (this.user.is_user) {
        this.showMediaAnalysis = true
      }
    }
  }
}
</script>

<style scoped>
.report-container {
  width: 100%;
  min-height: calc(100vh - 60px);
  padding: 24px;
  background: #F5F5F5;
}

.report-header {
  margin-bottom: 24px;
}

.report-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.report-description {
  font-size: 14px;
  color: #666;
}

.report-content {
  background: white;
  border-radius: 8px;
  padding: 32px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  height: calc(100vh - 140px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.placeholder-box {
  text-align: center;
  padding: 48px;
}

.placeholder-box h3 {
  font-size: 20px;
  font-weight: 600;
  margin: 16px 0 8px;
  color: #333;
}

.placeholder-box p {
  color: #666;
  margin-bottom: 32px;
}

.feature-list {
  display: flex;
  justify-content: center;
  gap: 32px;
  margin-top: 32px;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  min-width: 120px;
}

.feature-item i {
  font-size: 32px;
  color: #007bff;
}

.feature-item span {
  font-size: 14px;
  color: #333;
}

.feature-item:hover {
  background: #f5f5f5;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.statistics-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.statistics-header {
  padding: 16px 24px;
  border-bottom: 1px solid #E5E5E5;
  background: white;
}

.statistics-wrapper {
  flex: 1;
  overflow-y: auto;
  background: #f5f5f5;
}

.analysis-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.analysis-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  flex-shrink: 0;
}

.report-wrapper {
  flex: 1;
  height: calc(100% - 80px);
  overflow-y: auto;
  overflow-x: hidden;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  background: white;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.2s;
}

.back-button:hover {
  background: #f5f5f5;
  border-color: #ccc;
}

.analysis-header h2 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
}
.analysis-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  padding: 12px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 100;
}

.analysis-header h2 {
  margin: 0;
  flex-shrink: 0;
}

/* ステップナビゲーション */
.step-navigation {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 0;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
}

.step-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e0e0e0;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 11px;
  margin-bottom: 2px;
  transition: all 0.3s;
}

.step-label {
  font-size: 11px;
  color: #666;
  transition: all 0.3s;
  white-space: nowrap;
}

.step-item.active .step-number {
  background: #D50474;
  color: white;
  box-shadow: 0 0 0 2px rgba(213, 4, 116, 0.3);
}

.step-item.active .step-label {
  color: #D50474;
  font-weight: 600;
}

.step-item.completed .step-number {
  background: #D50474;
  color: white;
  opacity: 0.6;
}

.step-item.completed .step-label {
  color: #D50474;
  opacity: 0.6;
}

.step-connector {
  width: 50px;
  height: 2px;
  background: #e0e0e0;
  margin: 0 10px;
  margin-bottom: 15px;
  transition: all 0.3s;
}

.step-connector.completed {
  background: #D50474;
}

.step-item:hover .step-number {
  transform: scale(1.1);
}

/* 媒体別レポート用スタイル */
.media-analysis-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.media-analysis-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  flex-shrink: 0;
}

.media-analysis-header h2 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.media-analysis-wrapper {
  flex: 1;
  overflow-y: auto;
  background: #f5f5f5;
  padding: 20px;
}

</style>


// WEBPACK FOOTER //
// src/views/DashBoard/Report/ReportView.vue